<template>
    <div>
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="8" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
            </b-col>
        </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <loading :active = "loadCounter > 0"
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true"
                :is-full-page="true">
            </loading>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col lg="6">
                                        <div>
                                            <span style="font-weight: bold">{{document_title}} </span>
                                        </div>
                                    </b-col>
                                    <b-col lg="6">
                                        <base-button icon type="default" class="float-right mr-4" @click.native="onClickHistory" v-if="receipt.contact_id != null"><i class="fas fa-question"></i></base-button>
                                        <base-button icon type="success" class="float-right mr-4" @click="newDocument" v-if="(is_edit == 0 && receipt.is_void != '1' && receipt.time_printed == null)">
                                            <i class="fas fa-plus"></i>
                                        </base-button>

                                        <base-button icon type="warning" class="float-right mr-4" @click="voidDocument" v-if="($route.params.id != '_new' && receipt.is_void != '1' && receipt.time_printed == null)">
                                            {{language_terms['VOID']}}
                                        </base-button>
                                        <i class="fa fa-exclamation-triangle float-right text-red fa-3x" v-if="receipt.is_void == '1'" ></i>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col md="2">
                                    <base-input :label="language_terms['PAYMENT_MODE']">
                                        <el-select
                                            @change="retrieveItems(receipt.contact_id)"
                                            v-model="receipt.mode"
                                            filterable
                                            :placeholder="language_terms['PAYMENT_MODE']"
                                            :disabled="!is_edit || receipt.code != null">
                                            <el-option
                                                v-for="option in payment_modes"
                                                :key="option.code"
                                                :label="language_terms[option.name]"
                                                :value="option.code">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" v-if="0">
                                    <base-input label="Apply Mode">
                                        <el-select
                                            @change="onChangeApplyModeType"
                                            v-model="receipt.apply_mode"
                                            filterable
                                            :disabled="!is_edit">
                                            <el-option
                                                v-for="option in entity_types"
                                                :key="option.code"
                                                :label="option.name"
                                                :value="option.name">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="6">
                                    <label class="form-control-label">{{language_terms['ENTITY']}}</label>
                                        <base-input v-model="receipt.contact_name" v-if="(!is_edit || $route.params.id != '_new')" disabled></base-input>
                                        <multiselect
                                            v-else
                                            :internalSearch = "false"
                                            v-model="receipt.customer"
                                            ref="multiselcetRef"
                                            label="name"
                                            track-by="id"
                                            open-direction="bottom"
                                            :preserve-search="false"
                                            :options="customers"
                                            :multiple="false"
                                            :searchable="true"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :options-limit="300"
                                            :limit="50"
                                            :limit-text="limitText"
                                            :max-height="600"
                                            :show-no-results="false"
                                            :hide-selected="false"
                                            @search-change="asyncFindCustomer"
                                            @input="onSelectEntity"
                                            :taggable="receipt.default_debtor_account_code != '151300'"
                                            @tag="addTag($event)"
                                            >
                                        </multiselect>
                                </b-col>
                                <b-col md="2" v-if="receipt.mode != 'CONTRA'">
                                    <!-- <base-input v-model="receipt.currency_code" :label="language_terms['CURRENCY_CODE']" disabled="!is_edit"></base-input> -->
                                    <base-input :label="language_terms['SETTLEMENT_CURRENCY']">
                                        <el-select
                                            @change="retrieveItems(receipt.contact_id)"
                                            v-model="receipt.currency_code"
                                            filterable
                                            :disabled="!is_edit || receipt.mode == 'BAD_DEBTS' || receipt.code != null">
                                            <el-option
                                                v-for="option in currencies"
                                                :key="option.id"
                                                :label="option.code"
                                                :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" v-if="receipt.mode == 'CONTRA'">
                                    <!-- <base-input v-model="receipt.currency_code" :label="language_terms['CURRENCY_CODE']" disabled="!is_edit"></base-input> -->
                                    <base-input label="Contra From">
                                        <el-select
                                            v-model="contra_from"
                                            filterable
                                            :disabled="!is_edit">
                                            <el-option
                                                v-for="option in contra_options"
                                                :key="option.code"
                                                :label="option.name"
                                                :value="option.code">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" class="mt-4" v-if="receipt.mode == 'CONTRA'">
                                    <base-button class="mt-2" type="success"  @click="onClickExchangeRates()"
                                        v-if="is_edit && receipt.currencies.length > 0">
                                        Exchange Rates .
                                    </base-button>

                                    <base-button class="mt-2" type="primary" @click.native="onClickAutoApply" 
                                    v-if="is_edit && receipt.mode != 'CONTRA' ">
                                    Auto Apply
                                    </base-button>
                                    <base-button class="mt-2" type="primary" @click.native="onClickSumAll" 
                                    v-if="is_edit && receipt.mode == 'BAD_DEBTS' ">
                                    Sum All
                                    </base-button>
                                    <!-- <base-button class="mt-2" type="default" @click.native="onClickHistory" v-if="is_edit && receipt.mode != 'CONTRA'">History</base-button>                                         -->
                                </b-col>

                                <b-col md="2" v-if="receipt.mode != 'CONTRA'">
                                    <base-input :label="language_terms['TOTAL_AMOUNT']" :value="(receipt.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                                </b-col>
                            </b-row>
                            <b-row  v-if="receipt.mode != 'CONTRA'">
                                <b-col md="2">
                                    <base-input :label="language_terms['DATE']" v-if="is_edit">
                                        <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        style="background-color: white"
                                        class="form-control datepicker"
                                        v-model="receipt.date">
                                        </flat-picker>
                                    </base-input>
                                    <base-input
                                        :label="language_terms['DATE']"
                                        v-model="receipt.date"
                                        v-if="!is_edit"
                                        type="date"
                                        disabled
                                    ></base-input>
                                </b-col>

                                <b-col md="2" v-if="requires_bankaccount || !is_edit && receipt.mode != 'CN'">
                                    <base-input :label="language_terms['BANK_ACCOUNT']">
                                        <el-select
                                            v-model="receipt.bankaccount_id"
                                            filterable
                                            :placeholder="language_terms['BANK_ACCOUNT']"
                                            :disabled="!is_edit "
                                            >
                                            <el-option
                                                v-for="option in company_bankaccounts"
                                                :key="option.id"
                                                :label="option.code"
                                                :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" v-if="requires_bankaccount || !is_edit && receipt.mode != 'CN'">
                                    <base-input v-model="receipt.bank_fees_amount" :label="language_terms['BANK_CHARGE']"
                                    :placeholder="language_terms['BANK_CHARGE']"
                                    type="number" :disabled="!is_edit "></base-input>
                                </b-col>
                                <b-col md="6">
                                    <base-input v-model="receipt.reference" :label="language_terms['REFERENCE']" :disabled="!is_edit"></base-input>
                                </b-col>
                                <b-col md="2" v-if="receipt.mode == 'CN'">
                                    <base-input v-if="is_edit == 1" label="Tag Invoice">
                                        <el-select 
                                        clearable
                                        v-model="receipt.tagged_document_id"
                                        filterable
                                        :placeholder="language_terms['INVOICE']"
                                        :disabled="(!is_edit)">
                                            <el-option
                                                v-for="option in receipt.items_all"
                                                :key="option.document_id"
                                                :label="option.document_number"
                                                :value="option.document_id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                    <base-input v-else v-model="receipt.tagged_document_code" :label="language_terms['INVOICE']" :disabled="!is_edit"/>
                                </b-col>
                                <b-col md="2" v-if="receipt.mode == 'CN'">
                                    <base-input v-if="is_edit == 1" label="GST (%)" type="number" v-model="receipt.tax_rate_percent" @change="recomputeCNAmount()" :disabled="!is_edit || receipt.code != null"/>
                                    <base-input v-else v-model="receipt.tax_rate_percent" label="GST (%)" :disabled="!is_edit"/>
                                </b-col>

                                <b-col md="2" v-if="receipt.mode == 'CN' && 0">
                                    <base-input :label="language_terms['SALESPERSON']">
                                        <el-select 
                                        clearable
                                        v-model="receipt.salesperson_contact_id"
                                        filterable
                                        :placeholder="language_terms['SALESPERSON']"
                                        :disabled="(!is_edit || receipt.default_salesperson_contact_id != null)">
                                        <el-option
                                            v-for="option in salesperson_list"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                        </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col md="2" v-if="receipt.mode == 'CN' && 0">
                                    <base-input type="number" v-model="receipt.tax_rate_percent" label="GST (%)" :disabled="!is_edit"></base-input>
                                </b-col>

                                <b-col md="12">
                                    <base-input :label="language_terms['REMARKS']">
                                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" :disabled="!is_edit" v-model="receipt.remarks"/>
                                    </base-input>
                                </b-col>
                            </b-row>
                            <b-card v-if="receipt.apply_mode == 'INVOICE' && receipt.customer != null && receipt.customer.id != null && receipt.currency_code != null && receipt.items.length >= 0 && ((!is_edit && receipt.code != null) || (is_edit && receipt.code == null))">
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="12">
                                            <h3>Documents</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row v-if="receipt.mode == 'BAD_DEBTS'">
                                    <b-col md="2">
                                        <base-input v-model="receipt.amount"
                                        :label="receipt.mode != 'BAD_DEBTS' ? 'Credit Amount' : 'Write-off Amount'"
                                        type="number" :disabled="!is_edit"/>
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :value="(total_sales_os_amount_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled :label="language_terms['OUTSTANDING_AMOUNT'] + ' (SGD)'" ></base-input>
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :value="((receipt.amount * 1 + receipt.amount_adjusted * 1) - total_allocated_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled :label="language_terms['UNALLOCATED_AMOUNT']" ></base-input>
                                    </b-col>
                                    <b-col md="4" class="mt-4">
                                        <base-button class="mt-2" type="success"  @click="onClickExchangeRates()"
                                            v-if="is_edit && receipt.mode != 'CONTRA' && receipt.currencies.length > 0">
                                            Exchange Rates ..
                                        </base-button>

                                        <base-button class="mt-2" type="primary" @click.native="onClickAutoApply" 
                                        v-if="is_edit && receipt.mode != 'CONTRA' ">
                                        Auto Apply
                                        </base-button>
                                        <base-button class="mt-2" type="primary" @click.native="onClickSumAll" 
                                        v-if="is_edit && receipt.mode == 'BAD_DEBTS' ">
                                        Sum All
                                        </base-button>
                                        <!-- <base-button class="mt-2" type="default" @click.native="onClickHistory" v-if="is_edit && receipt.mode != 'CONTRA'">History</base-button>                                         -->
                                    </b-col>
                                </b-row>
                                <!-- <b-row><b-col>{{(requires_bankaccount && (receipt.customer != null && receipt.items.length >= 0 || receipt.pitems.length != 0)) || receipt.mode == 'CN' || receipt.mode == 'OFFSET' || receipt.mode == 'CONTRA'}}</b-col></b-row> -->
                                <b-row v-if="(requires_bankaccount && (receipt.customer != null && receipt.items.length >= 0 || receipt.pitems.length != 0)) || receipt.mode == 'CN' || receipt.mode == 'OFFSET' || receipt.mode == 'CONTRA'">
                                    <b-col md="2" v-if="receipt.mode == 'CN'">
                                        <base-input v-model="receipt.amount_gross"
                                        label="CN Amount (Before GST)"
                                        type="number" :disabled="!is_edit"
                                        @input="recomputeCNAmount()"                                        
                                        />
                                    </b-col>
                                    <b-col md="2" v-if="receipt.mode != 'CONTRA'">
                                        <base-input v-model="receipt.amount"
                                        :label="receipt.mode == 'CN' ? 'CN Amount' : 'Credit Amount'"
                                        type="number" :disabled="!is_edit || receipt.mode == 'CN'"/>
                                    </b-col>
                                    <b-col md="1" v-if="receipt.mode != 'CONTRA'">
                                        <base-input v-model="receipt.amount_adjusted" :label="language_terms['ADJUSTMENT']"
                                            type="number" :disabled="!is_edit">
                                        </base-input>
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :value="(total_sales_os_amount_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled :label="language_terms['OUTSTANDING_AMOUNT'] + ' (SGD)'" ></base-input>
                                    </b-col>
                                    <b-col md="2">
                                    <!--aaa-->
                                        <base-input :value="((receipt.amount * 1 + receipt.amount_adjusted * 1) - total_allocated_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled :label="language_terms['UNALLOCATED_AMOUNT']" ></base-input>
                                    </b-col>
                                    <b-col md="2" v-if="receipt.pending_offset_amount_home && receipt.pending_offset_amount_home != 0">
                                        <base-input :value="(receipt.pending_offset_amount_home * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled label="Offset Amount (SGD)" ></base-input>
                                    </b-col>

                                    <b-col md="3" class="mt-4">
                                        <base-button class="mt-2" type="danger" @click="onClickOffset()"
                                            v-if="is_edit && receipt.mode != 'CONTRA' && receipt.pending_offset_amount_home != 0">
                                            Offset
                                        </base-button>

                                        <!-- <base-button class="mt-2" type="success" @click="onClickExchangeRates()" v-if="is_edit && receipt.mode != 'CONTRA' && receipt.currencies.length > 0"> -->
                                        <base-button class="mt-2" type="success" @click="onClickExchangeRates()" v-if="is_edit && receipt.currencies.length > 0">
                                            Exchange Rates
                                        </base-button>

                                        <base-button class="mt-2" type="primary" @click.native="onClickAutoApply" 
                                        v-if="is_edit && receipt.mode != 'CONTRA' ">
                                        Auto Apply
                                        </base-button>
                                        
                                        <!-- <base-button class="mt-2" type="default" @click.native="onClickHistory" v-if="is_edit && receipt.mode != 'CONTRA'">History</base-button>                                         -->
                                    </b-col>
                                </b-row>
                                <!---<p>{{this.receipt.customer }}</p>debug-->

                                <b-row class="" v-if="receipt.customer != null && receipt.items.length > 0 && receipt.currency_code != null && (receipt.tagged_document_id == null || receipt.tagged_document_id == '')">
                                    <b-col md="8">
                                        <b>{{$route.params.id == '_new' ? receipt.items.length + ' ' + language_terms["OUTSTANDING_INVOICES"] : language_terms["INVOICES"]}}</b>
                                    </b-col>
                                    <!-- <b-col md="4">
                                        <base-button class="mt-2" type="default" @click.native="onClickHistory" v-if="is_edit && receipt.mode != 'CONTRA'">History</base-button>
                                    </b-col> -->
                                    <b-col sm="12" class="mt-3">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['DATE']}}</b-th>
                                                <b-th>{{language_terms['DOCUMENT']}}</b-th>
                                                <b-th>{{language_terms['CURRENCY']}}</b-th>
                                                <b-th>{{language_terms['AMOUNT']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>Home (SGD)</b-th>
                                                <!-- <b-th></b-th> -->
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(invoice, i) in receipt.items" :key="i"  @click="onClickApplySales(invoice, i)">
                                                    <!-- <td>{{moment(invoice.document_date).format("DD/MM/YYYY")}}</td> -->
                                                    <td>{{invoice.document_date}}</td>
                                                    <td>{{invoice.document_number}} {{invoice.document_reference != null && invoice.document_reference != '' ? ' / ' + invoice.document_reference : ''}}</td>
                                                    <td>{{invoice.currency_code}}</td>
                                                    <td>{{invoice.document_type == 'R' ? '(' : ''}}
                                                        {{(invoice.document_nett_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}
                                                        {{invoice.document_type == 'R' ? ')' : ''}}
                                                    </td>
                                                    
                                                    <td>
                                                        <span v-if="(!is_edit )">{{(invoice.balance * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</span>
                                                        <span v-else>
                                                            {{invoice.document_type == 'R' ? '(' : ''}}
                                                            {{(invoice.balance_exclude ? invoice.balance_exclude : invoice.balance * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}
                                                            {{invoice.document_type == 'R' ? ')' : ''}}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount" @input="performExchange(invoice)" :placeholder="language_terms['APPLY']" type="number" v-if="is_edit"></base-input>
                                                        <span v-else>{{(invoice.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</span>
                                                    </td>
                                                    <td>
                                                        {{ (invoice.amount_settlement * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}) }}
                                                        <!-- <base-input v-model="invoice.amount_settlement"
                                                            :placeholder="language_terms['APPLY']" type="number"
                                                            v-if="is_edit" :disabled="invoice.currency_code == receipt.currency_code"></base-input>
                                                        <span v-else>{{ (invoice.amount_settlement * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}) }}</span> -->
                                                    </td>
                                                    
                                                    <!-- <td> -->
                                                        <!-- <base-button type="success" @click.native="onClickApply(invoice, i)" class="mr-4" v-if="is_edit && receipt.mode != 'CONTRA'"> -->
                                                        <!-- <base-button type="success" @click.native="onClickApplySales(invoice, i)" class="mr-4" v-if="is_edit">
                                                            {{language_terms['APPLY']}}
                                                        </base-button> -->
                                                    <!-- </td> -->
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4" v-if="is_edit && receipt.customer != null && receipt.items.length > 0 && receipt.currency_code != null && receipt.mode == 'CONTRA' && receipt.pitems.length != 0">
                                    <b-col md="12">
                                        <b>{{$route.params.id == '_new' ? language_terms["OUTSTANDING_PURCHASE_INVOICES"] : language_terms["PURCHASE_INVOICES"]}}</b>
                                    </b-col>
                                    <b-col cols="12" class="mt-3">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['DATE']}}</b-th>
                                                <b-th>{{language_terms['DOCUMENT']}}</b-th>
                                                <b-th>{{language_terms['CURRENCY']}}</b-th>
                                                <b-th>{{language_terms['AMOUNT']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['BALANCE']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>{{language_terms['APPLY']}} ({{receipt.currency_prefix}})</b-th>
                                                <b-th>Home (SGD)</b-th>
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(invoice, i) in receipt.pitems" :key="i">
                                                    <td>{{invoice.document_date}}</td>
                                                    <td>{{invoice.reference}}</td>
                                                    <!-- <td>{{invoice.reference}} / {{invoice.document_number}}</td> -->
                                                    <td>{{invoice.currency_code}}</td>
                                                    <td>{{invoice.document_nett_amount}}</td>
                                                    <td>
                                                        <span v-if="(!is_edit )">{{(invoice.balance * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</span>
                                                        <span v-else>{{(invoice.balance_exclude ? invoice.balance_exclude : invoice.balance * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount" :placeholder="language_terms['APPLY']" type="number" v-if="is_edit"></base-input>
                                                        <span v-else>{{(invoice.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</span>
                                                    </td>
                                                    <td>
                                                        <base-input v-model="invoice.amount_settlement" @input="performExchange(invoice)" :placeholder="language_terms['APPLY']" type="number" v-if="is_edit"></base-input>
                                                        <span v-else>{{(invoice.amount_settlement * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</span>
                                                    </td>
                                                    <td>
                                                        <!-- <base-button type="success" @click.native="onClickApply(invoice, i)" class="mr-4" v-if="is_edit && receipt.mode != 'CONTRA'"> -->
                                                        <base-button type="success" @click.native="onClickApplyPurchase(invoice, i)" class="mr-4" v-if="is_edit">
                                                            {{language_terms['APPLY']}}
                                                        </base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <b-card v-if="receipt.apply_mode == 'GL' && receipt.customer != null && receipt.currency_code != null">
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="10">
                                            <h3>{{language_terms['RECEIVE_FOR']}}</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row v-if="receipt.default_debtor_account_code != '151300' && is_edit">
                                    <b-col :md="item.account_item.is_taggable == '1' ? 3:6">
                                        <label class="form-control-label">{{language_terms['ACCOUNT']}}</label>
                                        <multiselect
                                            v-model="item.account_item"
                                            :disabled="!is_edit"
                                            :options="account_list"
                                            track-by="code"
                                            :multiple="false" :close-on-select="true" :clear-on-select="false" open-direction="bottom" label="name" text-field="display_name"
                                        />
                                    </b-col>
                                    <b-col md="3" v-if="receipt.default_debtor_account_code != '151300' && is_edit && item.account_item.is_taggable == '1'">
                                        <label class="form-control-label">{{language_terms['ACCOUNT_TAG']}}</label>
                                        <multiselect
                                            v-model="item.account_item_tag"
                                            :disabled="!is_edit"
                                            :options="item.account_item.tags"
                                            :multiple="false"
                                            :taggable="true"
                                            @tag="addAccountItemTag($event)"
                                            />
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :label="language_terms['AMOUNT']" v-model="item.amount" type="NUMBER" :disabled="!is_edit"></base-input>
                                    </b-col>
                                    <b-col md="3">
                                        <base-input :label="language_terms['REMARKS']" v-model="item.remarks" :disabled="!is_edit"></base-input>
                                    </b-col>
                                    <b-col md="1" class="mt-4">
                                        <b-button variant="primary" @click="addAccountItem()" :disabled="!is_edit" class="mt-2">
                                            {{language_terms['ADD']}}
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" v-if="receipt.items.length > 0">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['ACCOUNT_CODE']}}</b-th>
                                                <b-th>{{language_terms['ACCOUNT_NAME']}}</b-th>
                                                <b-th>{{language_terms['AMOUNT']}}</b-th>
                                                <b-th>{{language_terms['REMARKS']}}</b-th>
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(item, index) in receipt.items" :key="index">
                                                    <td>{{item.account_item_code}}</td>
                                                    <td>{{item.account_item_name}}{{item.account_item_tag != null ? ' (' + item.account_item_tag + ')' : ''}}</td>
                                                    <td>{{(item.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                                    <td>{{item.remarks}}</td>
                                                    <td v-if="is_edit">
                                                        <base-button  size="sm" icon type="danger" @click="deleteItem(index)"><i class="fas fa-trash-alt"></i ></base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <div class="floating-bar" v-if="receipt.customer != null && receipt.items.length >= 0 && receipt.currency_code != null">
                                <div class="floating-bar-container" align="center">
                                    <b-button-group >
                                        <!-- <b-button class="transparent-btn" @click="addSaleItems" v-if="((sales_document.contact_id != null && sales_document.contact_id != '') && is_edit)">
                                        <i class="fas fa-plus mr-2 text-warning"></i>{{language_terms['ADD']}}
                                        </b-button> -->
                                        <b-button class="transparent-btn" @click="onClickEdit()"  v-if="!is_edit">
                                        <i class="fas fa-edit mr-2 text-info"></i>{{language_terms['EDIT']}}
                                        </b-button>
                                        <b-button class="transparent-btn" @click="printDocument"  v-if="!is_edit">
                                        <i class="fas fa-print mr-2 text-info"></i>{{language_terms['PRINT']}}
                                        </b-button>
                                        <b-button class="transparent-btn" @click="saveDocument" v-if="is_edit">
                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                        </b-button>
                                        <b-button class="transparent-btn" @click="onClickClose">
                                        <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CLOSE']}}
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </div>
                        </card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-modal id="modal-history" header-bg-variant="dark" centered class="my-modal" size="xl" hide-footer>
            <template>
                <b-row class="align-items-center mt--2">
                <b-col md="12" fluid class="mt--7">
                    <h3 style="color: white;">Receivables History</h3>
                </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col lg="12" md="10" sm="8" class="mb-3">
                <b-form-input v-model="history.filter" type="search" placeholder="Search"></b-form-input>&nbsp;
                </b-col>
                <b-col cols="12">
                    <div class="table-responsive">
                    <b-pagination
                        v-model="history.currentPage"
                        :total-rows="history.data.length"
                        :per-page="history.perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                        <b-table
                            :items="history.data"
                            :fields="history.fields"
                            :current-page="history.currentPage"
                            :filter="history.filter"
                            :filter-included-fields="history.filterOn"
                            :per-page="history.perPage"
                            show-empty
                            @filtered="onFiltered">
                            <template #cell(amount)="row">
                            {{(row.item.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="modal-currencies" hide-footer>
            <template #modal-title>
            Currency Exchange Rates (To SGD)
            </template>
            <div class="d-block text-center">
                <b-table-simple hover responsive>
                    <b-thead head-variant="light">
                        <b-th>{{ language_terms['CURRENCY']}}</b-th>
                        <b-th>Booked Rate</b-th>
                    </b-thead>
                    <b-tbody>
                        <tr v-for="(currency, i) in receipt.currencies" :key="i">
                            <td><h1>{{currency.currency_code}} to SGD</h1></td>
                            <!-- <td><base-input :disabled="currency.currency_code == receipt.currency_code" v-model="currency.exchange_rate" type="number"/></td> -->
                            <td><base-input :disabled="currency.currency_code == 'SGD'" v-model="currency.exchange_rate" type="number"/></td>
                        </tr>
                    </b-tbody>
                </b-table-simple>            
            </div>
            <base-button type="success" class="mt-3" block @click="onClickBookExchange">Book Rates</base-button>
        </b-modal>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { Select, Option} from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import axios from "axios";
import { apiRoutes } from "../../../apiRoutes";
import { authHeader } from "../../../global";
import moment from "moment";
import Vue from 'vue'
import BaseInput from '../../../components/Inputs/BaseInput.vue';

export default {
  props: {
    type:
    {
      type: String,
      default: "SALES",
      description: "Receipt Type",
      required: true,
    }
  },
  components:{
    Loading,
    [Select.name]: Select,
    flatPicker,
    [Option.name]: Option,
    BaseInput
  },
  computed: {
    requires_bankaccount()
    {
        let v = 0
        this.payment_modes.forEach((o, i) =>
        {
            if (o.code == this.receipt.mode)
                v = o.requires_bankaccount
        })

        return v
    },
    ...mapState({
        language_terms: (state) => state.languages.language_terms,
        selected_lang: (state) => state.languages.selected_langauge,
        outstanding_sales_invoices: (state) => state.sales.outstanding_sales_invoices,
        currency_prefix: (state) => state.currencies.prefix,
        is_receipt_created: (state) => state.receipts.is_created,
        is_receipt_updated:(state) => state.receipts.is_updated,
        receipt_is_voided: (state) => state.receipts.is_voided,
        receipt_filter: (state) => state.receipts.filter,
        receipt_data: (state) => state.receipts.data,
        company_bankaccounts: (state) => state.bankAccounts.company_bankaccounts,
        fys: (state) => state.accounts.fys,
        accounts_for_fy: (state) => state.accounts.accounts_for_fy,
        fy_by_date: (state) => state.accounts.fy_by_date,
        salesperson_list: (state) => state.employees.salesperson_list,

    }),
    total_sales_os_amount_home: function() {
            var total = 0

            if (this.receipt.items.length > 0) {
                this.receipt.items.forEach((o, index) => {
                    total += this.fxAmountToHomeCurrency(o.currency_code, o.balance * 1) * 1
                })
            }

            if (isNaN(total))
                total = 0

            return parseFloat((total * 1).toFixed(2));
    },
    total_purchases_os_amount_home: function() {
        var total = 0

        if (this.receipt.pitems.length > 0) {
            this.receipt.pitems.forEach((o, index) => {
                total += this.fxAmountToHomeCurrency(o.currency_code, o.balance) * 1
            })
        }

        return parseFloat((total * 1).toFixed(2));
    },
    total_allocated_amount: function()
    {
        var amount = 0

        if (this.is_edit)
        {
            if (!this.receipt.items) {
                amount = 0
            }
            else
            {
                this.receipt.items.forEach((o, index) => {
                    if (o.amount_settlement && !isNaN(o.amount_settlement))
                        amount += (o.amount_settlement * 1)
                })

                if (this.receipt.mode == 'CONTRA')
                {
                    this.receipt.pitems.forEach((o, index) => {
                    if (o.amount_settlement && !isNaN(o.amount_settlement))
                        amount -= (o.amount_settlement * 1)
                    })
                }
            }
            amount = this.fxHomeAmountToCurrency(this.receipt.currency_code, amount)
        }
        else
        {
            this.receipt.items.forEach((o, index) => {
                amount += o.amount * 1
            })            
        }
        return amount
    }
  },
  data(){
      return{
        contra_from:"SALES",
        contra_options:
        [
            {code:"SALES", name:"SALES"},
            {code:"PURCHASE", name:"PURCHASE"},
        ],

        history:{
            currentPage: 1,
            perPage: 10,
            filter:"",
            filterOn:[],
            fields:[
                { key: 'date', label: 'Date', sortable: true, sortDirection: 'desc' },
                { key: 'code', label: 'PV #', sortable: true, sortDirection: 'desc' },
                { key: 'currency_code', label: 'Currency'},
                { key: 'amount', label: 'Amount'},
                { key: 'bank_code', label: 'Bank A/C'},
                { key: 'reference', label: 'Reference'},
                { key: 'docs', label: 'Bills'},
            ],
            data:[],
        },
        ramount:null,
        fy:null,
        account_list:[],
        item:{
            account_item_tag:null,
            account_item:{is_taggable:0},
            account_item_code:null,
            account_item_name:null,
            debtor_contact_id:null,
            creditor_contact_id:null,
            amount:null,
            db_amount:null,
            cr_amount:null,
            direction:null,
        },
        entity_types:
        [
            {code:"INVOICE", name:"INVOICE"},
            {code:"GL", name:"GL"},
        ],
        currencies:[],
        temp_currencies:[],
        loadCounter:0,
        document_title:"",
        customers:[],
        payment_modes:[
            {code:"CHEQUE", name:"CHEQUE", "requires_bankaccount": 1},
            {code:"BANK_TRANSFER", name:"BANK_TRANSFER", "requires_bankaccount": 1},
            {code:"CASH", name:"CASH", "requires_bankaccount": 1},
            {code:"CONTRA", name:"CONTRA", "requires_bankaccount": 0},
            {code:"CN", name:"CREDIT_NOTE", "requires_bankaccount": 0},
            {code:"OFFSET", name:"OFFSET", "requires_bankaccount": 0},
            {code:"BAD_DEBTS", name:"BAD_DEBTS", "requires_bankaccount": 0},
        ],
        is_edit:false,
        receipt:{
            items_all:[],
            pending_offset_amount_home:0,
            apply_mode:'INVOICE',
            time_printed:null,
            is_void:null,
            customer:null,
            currency_code:"",
            contact_id:null,
            contact_code:'',
            contact_name:'',
            items:[],
            pitems:[],
            amount:null,
            amount_adjusted:0,
            mode:'CHEQUE',
            reference:'',
            remarks:"",
            currency_prefix:'',
            bankaccount_id:'',
            currencies:[],
            salesperson_contact_id:null,
            tagged_document_id:null,
            tax_rate_percent:9,
            }
        }
    },
    watch: {
      is_edit() {

    }
    },
    async mounted()
    {
        this.init(this.$route.params.id)
    },

  methods:
  {
    recomputeCNAmount()
    {
        if (this.receipt.mode == 'CN')
        {
            let gst_percent = parseFloat(this.receipt.tax_rate_percent)
            let m = (100 + gst_percent) / 100
            this.receipt.amount = (this.receipt.amount_gross * m).toFixed(2)
        }
    },
    onClickEdit()
    {
        // alert(this.is_edit)
        this.is_edit = true
        // alert(this.is_edit)
    },
    async onClickOffset()
    {
        this.receipt.mode = 'OFFSET'
        this.retrieveItems(this.receipt.contact_id)
    },
    fetchSalesPersons() {
      this.$store.dispatch("employees/fetchAllSalesPerson", {"role_code":"sales person"});
    },
    onFiltered(filteredItems) {
        this.history.currentPage = 1
    },
    onClickHistory()
    {
        this.retrieveHistory(this.receipt.contact_id)
        this.$bvModal.show('modal-history')
    },
    async retrieveHistory(contact_id)
    {
        this.loadingCounter++

        let url = apiRoutes["PURCHASERECEIPTS_RETRIEVE_HISTORY"]
        let payload = { contact_id: contact_id}
        await axios.post(url, payload, authHeader()).then((response) => {
            if (response.data.code == 1) {
                this.history.data = response.data.data;
            } else {
                this.history.data = [];
            }
        })
        .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}});

        this.loadingCounter--
    },
    printDocument()
    {
        this.loadingCounter++
        let url = 'https://reports.unityerp.com/esteam/sales-receipt/' + encodeURIComponent(localStorage.access_token)
        + '/' + encodeURIComponent(this.receipt.code)
        window.open(url , '_blank');
       
        this.loadingCounter--
    },
    onClickSumAll()
    {
        let amount = 0
        
        for (let i = 0; i < this.receipt.items.length; i++) {
            let invoice_os_amount = this.receipt.items[i].balance_exclude ? (this.receipt.items[i].balance_exclude * 1) : (this.receipt.items[i].balance * 1) * 1
            let amount_settlement = this.fxAmountToHomeCurrency(this.receipt.items[i].currency_code, invoice_os_amount) * 1

            this.receipt.items[i].amount = invoice_os_amount.toFixed(2)
            this.receipt.items[i].amount_settlement = amount_settlement.toFixed(2)
            amount = amount + amount_settlement
        }
        this.receipt.amount = amount.toFixed(2)
    },
    fxHomeAmountToCurrency(currency_code, amount)
    {
        if (currency_code == 'SGD')
            amount = amount * 1
        else
        {
            if (amount != 0 && this.receipt.currencies)
            {
                this.receipt.currencies.forEach((o, index) => {
                    if (o.currency_code == currency_code)
                    {
                        amount = ((amount * 1) / (o.exchange_rate * 1)) * 1
                    }
                })
            }
        }

        return amount
    },
    fxAmountToHomeCurrency(currency_code, amount)
    {
        if (currency_code == 'SGD')
            amount = amount * 1
        else
        {
            var currencies = this.receipt.currencies
            if (this.receipt.type == 'CONTRA')
                currencies = this.receipt.pitems.currencies
            else
                currencies = this.receipt.currencies

            if (amount != 0 && currencies)
            {
                currencies.forEach((o, index) => {
                    if (o.currency_code == currency_code)
                    {
                        amount = ((amount * 1) * (o.exchange_rate * 1)) * 1
                    }
                })
            }
        }

        return amount
    },
    onClickAutoApply() {
        let allocate_amount_home = parseFloat(this.receipt.amount) + parseFloat(this.receipt.amount_adjusted)
        allocate_amount_home = this.fxAmountToHomeCurrency(this.receipt.currency_code, allocate_amount_home)

        var settlement_amount = 0

        if (allocate_amount_home && allocate_amount_home <= this.total_sales_os_amount_home || 1) {            
            if (this.receipt.items.length > 0) {
                let amount_home = (allocate_amount_home * 1)
                let i = 0;

                for (i = 0; i < this.receipt.items.length; i++) {
                    let invoice_os_amount = this.receipt.items[i].balance_exclude ? (this.receipt.items[i].balance_exclude * 1) : (this.receipt.items[i].balance * 1) * 1
                    let invoice_os_amount_home = this.fxAmountToHomeCurrency(this.receipt.items[i].currency_code, invoice_os_amount) * 1

                    this.receipt.items[i].amount = null
                    if (amount_home > 0) {
                        if (amount_home > invoice_os_amount_home) {
                            settlement_amount = invoice_os_amount_home * 1
                        }
                        else {
                            settlement_amount = amount_home * 1
                        }
                        this.receipt.items[i].amount_settlement = (settlement_amount * 1).toFixed(2)
                        let applied_amount = this.fxHomeAmountToCurrency(this.receipt.items[i].currency_code, settlement_amount)
                        this.receipt.items[i].amount = (applied_amount * 1).toFixed(2)
                        
                        amount_home = amount_home - settlement_amount
                    }
                    else
                    {
                        this.receipt.items[i].amount = 0
                        this.receipt.items[i].amount_settlement = 0
                    }
                }
            }
        }
        else {
            Vue.notify({group: "notify", type: "error", text: "Invalid Payment Amount!", max: 5, duration: 5000, speed: 300,});
        }
    },    
    async onClickExchangeRates()
    {
        this.temp_currencies = this.receipt.currencies
        this.$bvModal.show('modal-currencies')
    },
    async onClickBookExchange()
    {
        this.receipt.currencies = this.temp_currencies
        this.$bvModal.hide('modal-currencies')

        this.receipt.items.forEach((o, index) => {
            o.amount_settlement = 0
            o.amount = 0
        })
    },
    performExchange(item)
    {
        if (this.is_edit)
        {
            let amount = 0
            amount = this.fxAmountToHomeCurrency(item.currency_code, item.amount)
            item.amount_settlement = (amount * 1).toFixed(2)
            item.amount_paid_home = (amount * 1).toFixed(2)
        }
    },
    // fxAmountToReceiptCurrency(currency_code, amount)
    // {
    //     if (amount != 0 && this.receipt.currencies)
    //     {
    //         this.receipt.currencies.forEach((o, index) => {
    //             if (o.currency_code == currency_code)
    //             {
    //                 amount = ((amount * 1) * (o.exchange_rate * 1)) * 1
    //             }
    //         })
    //     }

    //     return amount
    // },
    // fxAmountFromReceiptCurrency(currency_code, amount)
    // {
    //     if (amount != 0)
    //     {
    //         this.receipt.currencies.forEach((o, index) => {
    //             if (o.currency_code == currency_code)
    //             {
    //                 amount = ((amount * 1) / (o.exchange_rate * 1)) * 1
    //             }
    //         })
    //     }

    //     amount = (amount * 1).toFixed(2)
    //     return amount
    // },    
    async init(document_id)
    {
        this.loadCounter ++
        
        await this.$store.dispatch("accounts/fetchFYs", {})
        await this.$store.dispatch("employees/fetchAllSalesPerson", {"role_code":"sales person"});
        if(this.fys)
        {
            this.valid_fys = this.fys.filter(function(item)
            {
                return (item.fy != null);
            });null
            this.fy = this.valid_fys[0].fy
            this.getAllAccountsForFY()
        }

        if(document_id == '_new')
        {
            // if (localStorage.receipt)
            // {
            //     this.receipt = JSON.parse(localStorage.receipt)
            //     this.retrieveItems(this.receipt.contact_id)
            //     localStorage.removeItem('receipt')
            // }
            this.is_edit = true
            this.document_title = this.language_terms['NEW'] + " " + (this.type == 'SALES' ? this.language_terms['SALES_RECEIPT'] : this.language_terms['PURCHASE_RECEIPT'] )

            if(!this.receipt.date)
            {
                this.receipt.date = moment().format("YYYY-MM-DD");
            }
        }
        else
        {
            this.is_edit = false
            await this.retrieveDocument(document_id)
            this.document_title = this.receipt.code

                await this.asyncFindCustomer(this.receipt.contact_code);

                let selected_customer = {
                    id: this.receipt.contact_id,
                    code: this.receipt.contact_code,
                    name: this.receipt.contact_name,
                };

                this.receipt.customer = selected_customer;

                if(this.receipt.currency_code)
                {
                    await this.$store.dispatch("currencies/getPrefix", {currency_code:this.receipt.currency_code})
                    await this.$store.dispatch("bankAccounts/fetchCompanyAccounts", {currency_code:this.receipt.currency_code})
                }

        }

      this.loadCounter --

    },
    deleteItem(index)
    {
        this.receipt.items.splice(index, 1);

        this.item.amount = 0
        this.receipt.amount = 0
        this.receipt.items.forEach((i, index) => {
            this.receipt.amount += (i.amount * 1)
        })
    },
    isFoundInTagList(name)
    {
        let is_found = 0
        for(let i = 0; i < this.customers.length; i++)
        {
            if(this.customers[i].name == name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    isFoundInAccountTagList(name)
    {
        let is_found = 0
        for(let i = 0; i < this.item.account_item.tags; i++)
        {
            if(this.item.account_item.tags[i].name == name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    async addTag(newTag, index)
    {
      if (newTag)
      {
        let obj = {id: null, code: null, name:newTag}
        if(this.isFoundInTagList(newTag) == 0)
        {
            this.receipt.customer = obj
            this.customers.push(obj)
        }
        this.receipt.contact_id = null
        this.receipt.contact_code = null
        this.receipt.contact_name = newTag
      }
    },
    async addAccountItemTag(newTag, index)
    {
      if (newTag)
      {
        if(this.isFoundInTagList(newTag) == 0)
        {
            this.item.account_item.tags.push(newTag)
        }
        this.item.account_item_tag = newTag
      }
    },
    async addAccountItem()
    {
        let amount = this.item.amount

        if (this.item.account_item == null)
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Account has to be selected', max: 5, duration: 5000, speed: 300})
        }
        else if (amount == null || amount == '')
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Amount has to be entered', max: 5, duration: 5000, speed: 300})
        }
        else
        {
            this.item.account_item_code = this.item.account_item.code
            this.item.account_item_name = this.item.account_item.name

            let item = {
                account_item_code:this.item.account_item_code,
                account_item_name:this.item.account_item_name,
                debtor_contact_id:this.item.debtor_contact_id,
                creditor_contact_id:this.item.creditor_contact_id,
                amount:this.item.amount,
                db_amount:this.item.db_amount,
                cr_amount:this.item.cr_amount,
                direction:this.item.direction,
                remarks:this.item.remarks,
                account_item_tag:this.item.account_item_tag,
            }

            this.receipt.items.push(item)
            this.item.amount = null

            this.item.amount = 0
            this.receipt.amount = 0
            this.receipt.items.forEach((i, index) => {
                this.receipt.amount += (i.amount * 1)
            })

        }

    },
    async getAllAccountsForFY()
    {
        this.loadingCounter++
        let filter = {fy:this.fy}
        await this.$store.dispatch("accounts/getAccountForFys", filter)
        this.account_list = this.accounts_for_fy
        this.loadingCounter--
    },
    async onChangeApplyModeType()
    {
        this.receipt.items = []
        this.receipt.pitems = []
        this.receipt.customer = []
        await this.getCurrencies(null)
        this.receipt.currency_code = 'SGD'
        this.retrieveBankAccountsByCurrency(this.receipt.currency_code)

    },
    async getUnappliedAmount(i) {
        let amount = (this.receipt.amount * 1) + (this.receipt.amount_adjusted * 1)
        amount = this.fxAmountToHomeCurrency(this.receipt.currency_code, amount)
        
        let item_amount = 0
        for (let x = 0; x < this.receipt.items.length; x++) {
            if (i == x)
                item_amount = 0
            else
            {
                let currency_code = this.receipt.items[x].currency_code
                let amt = this.receipt.items[x].amount * 1
                item_amount = this.fxAmountToHomeCurrency(currency_code, amt)
            }
                
            if (amount > item_amount)
            {
                amount = amount - item_amount                    
            }
            else
                amount = 0
        }

        amount = parseFloat(amount.toFixed(2))
        return amount;
    },    
    async onClickApplySales(invoice, i) {
        if (this.receipt.mode != 'CONTRA')
        {
            this.onClickApply(invoice,i )
        }
        else
        {
            if (invoice.amount * 1 != 0)
            {
                invoice.amount = 0
                invoice.amount_settlement = 0
            }
            else
            {
                if (this.contra_from == 'SALES')
                {
                    invoice.amount = invoice.balance
                    invoice.amount_settlement = (this.fxAmountToHomeCurrency(invoice.currency_code, invoice.amount) * 1).toFixed(2)
                }
                else
                {
                    let invoice_home = (this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance).toFixed(2) * 1)
                    let salesHomeSum = await this.getContraSalesHomeSum()
                    let purchaseHomeSum = await this.getContraPurchaseHomeSum() - invoice.amount_settlement
                    if (purchaseHomeSum > salesHomeSum)
                    {
                        let amount_home = purchaseHomeSum - salesHomeSum
                        if (amount_home > invoice_home)
                            amount_home = invoice_home
                        else
                            amount_home = amount_home

                        invoice.amount_settlement = amount_home.toFixed(2)
                        invoice.amount = this.fxHomeAmountToCurrency(invoice.currency_code, amount_home).toFixed(2)
                    }
                }
            }            
        }        
    },
    async onClickApplyPurchase(invoice, i) {
        if (invoice.amount * 1 != 0)
        {
            invoice.amount = 0
            invoice.amount_settlement = 0
        }
        else
        {
            if (this.contra_from == 'PURCHASE')
            {
                invoice.amount = invoice.balance
                invoice.amount_settlement = (this.fxAmountToHomeCurrency(invoice.currency_code, invoice.amount) * 1).toFixed(2)
            }
            else
            {
                let invoice_home = (this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance).toFixed(2) * 1)
                let salesHomeSum = await this.getContraSalesHomeSum()
                let purchaseHomeSum = await this.getContraPurchaseHomeSum() - invoice.amount_settlement
                if (salesHomeSum > purchaseHomeSum)
                {
                    let amount_home = salesHomeSum - purchaseHomeSum
                    if (amount_home > invoice_home)
                        amount_home = invoice_home
                    else
                        amount_home = amount_home

                    invoice.amount_settlement = amount_home.toFixed(2)
                    invoice.amount = this.fxHomeAmountToCurrency(invoice.currency_code, amount_home).toFixed(2)
                }
            }
        }            
    },
    async getContraSalesHomeSum()
    {
        let amount = 0
        let items = this.receipt.items
        for (let x = 0; x < items.length; x++)
        {
            amount += items[x].amount_settlement * 1
        }
        return amount
    },
    async getContraPurchaseHomeSum()
    {
        let amount = 0
        let items = this.receipt.pitems
        for (let x = 0; x < items.length; x++)
        {
            amount += items[x].amount_settlement * 1
        }
        return amount
    },
    async onClickApply(invoice, i) {
        if (invoice.document_type == 'D')
        {
            if (invoice.amount * 1 != 0)
            {
                invoice.amount = 0
                invoice.amount_settlement = 0
            }
            else
            {
                let unapplied_amount_home = await this.getUnappliedAmount(i)
                let settlement_amount = 0
                let doc_balance_receipt_currency_home = 0
                let apply_amount = 0
                                                    
                doc_balance_receipt_currency_home = this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance)
                if (unapplied_amount_home > doc_balance_receipt_currency_home)
                {
                    settlement_amount = doc_balance_receipt_currency_home
                }
                else
                {
                    settlement_amount = unapplied_amount_home
                }
                apply_amount = this.fxHomeAmountToCurrency(this.receipt.items[i].currency_code, settlement_amount)
                
                invoice.amount = (apply_amount * 1).toFixed(2)
                invoice.amount_settlement = (settlement_amount * 1).toFixed(2)
            }
        }
        else if (invoice.document_type == 'R')
        {
            let settlement_amount = 0
            let doc_balance_receipt_currency = 0
            let apply_amount = 0
            let allow = 1
            let doc_balance_receipt_currency_home = 0

            allow = 1

            if (allow)
            {
                if (invoice.amount * 1 != 0)
                    doc_balance_receipt_currency_home = 0
                else
                {
                    doc_balance_receipt_currency_home = this.fxAmountToHomeCurrency(invoice.currency_code, invoice.balance) * -1
                }

                settlement_amount = doc_balance_receipt_currency_home
                apply_amount = this.fxHomeAmountToCurrency(this.receipt.items[i].currency_code, settlement_amount)
                
                invoice.amount = (apply_amount * 1).toFixed(2)
                invoice.amount_settlement = (settlement_amount * 1).toFixed(2)            
            }
        }

        this.$set(this.receipt.items, i, invoice)
    },
    async saveDocument()
    {
        let proceed = 1

        if (this.receipt.pending_offset_amount_home != 0)
        {
            proceed = 0
            let response = await this.$confirm('Proceed', 'O/S Offset Amount', {
                    cancelButtonText: this.language_terms['CANCEL'],
                    confirmButtonText: this.language_terms['CONFIRM'],
                    type: 'warning'
                    }).catch(() => 
                    {
                        // this.$message.info(this.language_terms['ACTION_CANCEL'])
                        proceed = 0
                    })

            if (response === 'confirm') 
            {
                proceed = 1
            }
        }

        if(this.$route.params.id == '_new')
        {
            if (proceed == 1)
            {
                this.create()
            }
        }
        else
        {
            this.update()
        }
    },
    async voidDocument()
    {
        await this.$store.dispatch("receipts/void", {"id": this.receipt.id})

        if(this.receipt_is_voided)
        {
            await this.searchReceipts()
            await this.routeToMaster();
        }
    },
    async newDocument()
    {
        if (this.receipt.mode == 'OFFSET')
        {
            this.receipt.mode = 'CHEQUE'
            localStorage.setItem('receipt', JSON.stringify(this.receipt))
        }
        window.location.href = '/finance/sales-receipt/_new';
    },
    moment: function () {
        return moment();
    },
    async retrieveDocument(code)
    {
      await this.$store.dispatch("receipts/fetch", {code: code,type: this.type});
      this.receipt = this.receipt_data;
      console.log(this.receipt)
    },
    async update()
    {
        let url = apiRoutes['UPDATE_SALE_RECEIPT']
        let msg = ''
        let payload = this.receipt
        // alert(url)
        await axios.post(url, payload, authHeader()).then((res) => {
            let response = res.data
            if (response.code == 1) 
            {
                let receipt_code = response.data.code
                Vue.notify({ text: 'Receipt (' + receipt_code + ')' + " has been updated!", type: 'success', group: 'notify', max: 5, duration: 5000, speed: 300 })
                window.location.href = '/finance/sales-receipt/' + encodeURIComponent(receipt_code);
            } else 
            {
                if (Array.isArray(response.data.errors)) 
                {
                    msg = response.data.errors.join("\n")
                }
                else
                {
                    msg = response.msg
                }
                Vue.notify({ text: msg, type: 'error', group: 'notify', max: 5, duration: 5000, speed: 300 })
            }
        })
        .catch((error) => {
        if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }});

        // this.receipt.type = this.type

        // await this.$store.dispatch("receipts/update", this.receipt)

        // if(this.is_receipt_updated)
        // {
        //     await this.searchReceipts()
        //     await this.routeToMaster();
        // }
    },
    async create()
    {
        this.receipt.type = this.type
        await this.$store.dispatch("receipts/create", this.receipt)

        if(this.is_receipt_created)
        {
            window.location.href = '/finance/sales-receipt/' + encodeURIComponent(this.is_receipt_created)
        }
    },
    routeToMaster()
    {
      if (this.type == "SALES")
      {
        this.$router.push("/finance/sales-receipts");
      }
      else if (this.type == "SO")
      {
      }

    },
    onClickClose()
    {
        this.$router.push("/finance/sales-receipts")
    },
    async searchReceipts(receipt_code)
    {
        this.loadCounter ++
        let filter = {
                        keyword:receipt_code,
                        date_from:null,
                        date_to:null,
                      }
        if(this.receipt_filter)
        {
            filter = this.receipt_filter
        }
        await this.$store.dispatch('receipts/quickSearch', filter)

        this.loadCounter --
    },
    async retrieveItems(contact_id, alt_contact_name = null)
    {
        this.loadCounter++

        this.receipt.pending_offset_amount_home = 0
        this.receipt.items = []
        this.receipt.pitems = []        
        if (contact_id != null && contact_id != '')
        {
            await this.retrieveBankAccountsByCurrency(this.receipt.currency_code)
            if (this.receipt.mode == 'BAD_DEBTS')
                this.receipt.currency_code = 'SGD'

            let url = apiRoutes['RETRIEVE_OUTSTANDING_SIS'];
            // alert(url)
            let include_receipts = 0
            let is_contra = 0

            if (this.receipt.mode == 'OFFSET')
                include_receipts = 1

            if (this.receipt.mode == 'CONTRA')
                is_contra = 1

            let payload = {contact_id:contact_id, type:this.type, include_receipts:include_receipts, currency_code:this.receipt.currency_code, is_contra:is_contra, alt_contact_name:alt_contact_name}
            await axios.post(url, payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.receipt.pending_offset_amount_home = response.data.data.pending_offset_amount_home                    
                    this.receipt.items = response.data.data.items
                    this.receipt.items_all = response.data.data.items_all
                    this.receipt.currencies = response.data.data.currencies
                } else {
                    this.receipt.pitems = [];
                }
                })
                .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}
                });
            
//            await this.getCurrencies(contact_id)

            if (this.receipt.mode == 'CONTRA')
            {
                // payload = {customer_contact_id:contact_id, currency_code:this.receipt.currency_code}
                payload = {customer_contact_id:contact_id, currency_code:this.receipt.currency_code}
                await axios.post(apiRoutes["PURCHASE_RETRIEVE_OS_INVOICES"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) {
                    this.receipt.pitems = response.data.data.items;
                    this.receipt.pitems.currencies = response.data.data.currencies
                } else {
                    this.receipt.pitems = [];
                }
                })
                .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}
                });

                if (this.receipt.items.length == 0 || this.receipt.pitems.length == 0)
                {
                    this.receipt.items = []
                    this.receipt.pitems = []
                    alert('Contra unavailable');
                }
            }

            await this.getCurrencies(contact_id)

            // console.log(this.receipt)
            this.receipt.amount = 0
            this.receipt.amount_adjusted = 0
            this.receipt.reference = null
        }
        this.loadCounter --;
    },
    async retrieveBankAccountsByCurrency(currency_code)
    {
        await this.$store.dispatch("bankAccounts/fetchCompanyAccounts", {currency_code:currency_code})

        if(this.company_bankaccounts.length > 0)
        {
            this.receipt.bankaccount_id = this.company_bankaccounts[0].id
        }

        this.receipt.currency_prefix = this.currency_prefix
    },
    async onSelectEntity(selectedOption)
    {
        if (selectedOption)
        {
            this.receipt.currency_code = selectedOption.currency_code
            if(this.$route.params.id == '_new' && this.receipt.apply_mode == 'INVOICE')
            {
                await this.retrieveItems(selectedOption.id, selectedOption.alt_contact_name)
            }

            if(selectedOption.currency_code)
            {
                await this.getCurrencies(selectedOption.id)
                await this.$store.dispatch("currencies/getPrefix", {currency_code:selectedOption.currency_code})
                await this.retrieveBankAccountsByCurrency(selectedOption.currency_code)
            }

            if (this.receipt.apply_mode == 'GL')
            {
                this.receipt.items = []
                this.receipt.pitems = []
            }

            if (this.receipt.mode == 'CN')
            {
                if (selectedOption.customer_tax_code == 'Z')
                {
                    this.receipt.tax_rate_percent = 0
                }
                else
                {
                    this.receipt.tax_rate_percent = 9
                }
            }
            this.receipt.contact_id = selectedOption.id
        }
    },
    limitText(count) {
      return `and ${count} other customers`;
    },
    async getCurrencies(contact_id)
    {
        let pv = {};
        await axios.post(apiRoutes["CURRENCIES_LIST"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.currencies = response.data.data;
          } else {
            this.currencies = [];
          }
          this.loadCounter --;
        })
        .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});}});
    },
    async asyncFindCustomer(query)
    {
      let payload = { value: query, default_debtor_account_code: this.receipt.default_debtor_account_code}
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          } else {
            this.customers = [];
          }

          this.loadCounter --;
        })
        .catch((error) => {if (error.response) {Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300, });}        });
    },
  }
}
</script>
